import { fromZonedTime } from 'date-fns-tz';

type CalculateDateRangeParams = {
  fromMs: number;
  toMs: number;
  tzName: string;
};

export const calculateDateRange = ({ fromMs, toMs, tzName }: CalculateDateRangeParams) => {
  const fromDate = new Date(fromMs);
  const toDate = new Date(toMs);

  const utcStart = fromZonedTime(fromDate, tzName);
  const utcEnd = fromZonedTime(toDate, tzName);

  return {
    recalculateFrom: Math.floor(utcStart.getTime() / 1000),
    recalculateTo: Math.floor(utcEnd.getTime() / 1000),
  };
};
